<template>
  <div class="nav-box">
    <!-- logo -->
    <img src="@/assets/home/logo.png" alt="" class="logo" />
    <!-- no logo -->
    <!-- <div class="logo"></div> -->
    <div class="href-box">
      <div
        @click="toHref(item)"
        class="nav-item"
        v-for="(item, index) in routeList"
        :key="index"
        :class="{ 'nav-active': item.name === active }"
      >
        {{ item.title }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      routeList: [
        {
          title: 'Home 首页',
          name: 'home',
        },
        {
          title: 'Business 业务',
          name: 'business',
        },
        {
          title: 'Case 案例',
          name: 'case',
        },
        {
          title: 'About 关于',
          name: 'about',
        },
        {
          title: 'Team 团队',
          name: 'team',
        },
        {
          title: 'Contact 联系',
          name: 'contact',
        },
      ],
    };
  },
  computed: {
    active() {
      return this.$store.state.route.activeRoute;
    },
  },
  mounted() {
    if (this.$route.name !== this.active) {
      this.$store.dispatch('updateActiveRoute', this.$route.name);
    }
  },
  methods: {
    toHref(item) {
      this.$router.push({
        name: item.name,
      });
      this.$store.dispatch('updateActiveRoute', item.name);
    },
  },
};
</script>
<style lang="scss" scoped>
@import url('./index.scss');
</style>
